<template>
  <!-- <footer class="footer">
    
    <div class="container-fluid d-flex flex-wrap justify-content-center">
      <nav>
        <ul>
          <li>
            <router-link :to="{ path: '/admin' }"> <h4 class="text-white"> DNTIC - EMI </h4></router-link>
            <hr>
          </li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
    
      </div>
    </div>
  </footer> -->
</template>
<script>
export default {};
</script>
<style></style>
